import { useEffect, useRef, useState } from "react";
import { inr, round2 } from "../utils/posBilling";
import { showError } from "../utils/toastUtils";

/**
 * Cart line ka editable price (bargaining).
 * Ceiling = MRP (MRP na ho to listed price). Cost se neeche jaaye to warning, block nahi.
 */
export default function CartPrice({ item, onChange }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState("");
  const inputRef = useRef(null);

  const ceiling = Number(item.mrp) > 0 ? Number(item.mrp) : Number(item.listPrice);
  const edited = round2(item.unitPrice) !== round2(item.listPrice);
  const belowCost = Number(item.costPrice) > 0 && Number(item.unitPrice) < Number(item.costPrice);

  useEffect(() => {
    if (editing) inputRef.current?.select();
  }, [editing]);

  const start = () => {
    setVal(String(item.unitPrice));
    setEditing(true);
  };

  const commit = () => {
    const p = round2(Number(val));
    if (!val || !Number.isFinite(p) || p <= 0) {
      setEditing(false);
      return;
    }
    if (p > ceiling + 0.009) {
      showError(`Price cannot be more than ${Number(item.mrp) > 0 ? "MRP" : "the listed price"} (${inr(ceiling)})`);
      return;
    }
    onChange(p);
    setEditing(false);
  };

  if (editing) {
    return (
      <div className="input-group input-group-sm pos-price-edit">
        <span className="input-group-text">₹</span>
        <input
          ref={inputRef}
          className="form-control"
          inputMode="decimal"
          value={val}
          onChange={(e) => /^\d*(\.\d{0,2})?$/.test(e.target.value) && setVal(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commit();
            } else if (e.key === "Escape") setEditing(false);
          }}
        />
      </div>
    );
  }

  return (
    <small className="text-muted d-flex align-items-center flex-wrap gap-1">
      {item.variantName && <span>{item.variantName} ·</span>}
      {edited && <span className="text-decoration-line-through">{inr(item.listPrice)}</span>}
      <button type="button" className={`pos-price-btn ${edited ? "is-edited" : ""}`} onClick={start} title="Edit price">
        {inr(item.unitPrice)} <i className="ti ti-pencil" />
      </button>
      {edited && (
        <button type="button" className="btn btn-link btn-sm p-0" onClick={() => onChange(item.listPrice)} title="Reset to listed price">
          Reset
        </button>
      )}
      {belowCost && <i className="ti ti-alert-triangle text-danger" title="Selling below cost price" />}
    </small>
  );
}